var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48632 7.52529C2.98124 9.04052 0.960938 9.04052 0.960938 9.04052C0.960938 9.04052 0.960937 7.02021 2.47617 6.51514",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03123 3.98969L5.00077 7.02015L2.98047 4.99984L6.01093 1.96938C7.15843 0.821876 8.30594 0.833069 8.79532 0.906085C8.87067 0.917317 8.94042 0.952457 8.99429 1.00633C9.04816 1.0602 9.0833 1.12994 9.09453 1.20529C9.16755 1.69467 9.17874 2.84218 8.03123 3.98969Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52538 4.49512V7.37764C7.52538 7.42454 7.51614 7.47098 7.4982 7.51431C7.48025 7.55764 7.45394 7.59702 7.42078 7.63018L5.97695 9.07401C5.93124 9.11972 5.87398 9.15216 5.81128 9.16789C5.74858 9.18361 5.68278 9.18202 5.62092 9.16329C5.55905 9.14456 5.50342 9.10938 5.45997 9.06152C5.41652 9.01366 5.38688 8.9549 5.3742 8.89151L5 7.0205",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50381 2.47461H2.62128C2.57438 2.47461 2.52794 2.48385 2.48461 2.5018C2.44128 2.51974 2.40191 2.54605 2.36875 2.57921L0.924917 4.02304C0.879208 4.06875 0.846762 4.12601 0.831038 4.18871C0.815315 4.25141 0.816904 4.31721 0.835637 4.37907C0.854369 4.44094 0.889542 4.49657 0.937406 4.54002C0.985269 4.58347 1.04403 4.61311 1.10741 4.62579L2.97843 4.99999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f6dffa5a1a615850def693f20ae68762.svg";
export { ForwardRef as ReactComponent };